import { baseApi as api } from './baseApi';
export const addTagTypes = ['ANALYSIS', 'CONFIGURATION', 'EXPERIMENT', 'EXPORT', 'SEARCH', 'UPLOAD', 'PROFILING'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      startClonotypeAnalysisApiStellarAnalysisExperimentIdClonotypeAnalysisPost: build.mutation<
        StartClonotypeAnalysisApiStellarAnalysisExperimentIdClonotypeAnalysisPostApiResponse,
        StartClonotypeAnalysisApiStellarAnalysisExperimentIdClonotypeAnalysisPostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/stellar/analysis/${queryArg.experimentId}/clonotype-analysis/`,
          method: 'POST',
          body: queryArg.barcodes,
          params: { clonotype_id: queryArg.clonotypeId, clonotype_method: queryArg.clonotypeMethod },
        }),
        invalidatesTags: ['ANALYSIS'],
      }),
      getBuildVersionApiStellarConfigurationBuildVersionGet: build.query<
        GetBuildVersionApiStellarConfigurationBuildVersionGetApiResponse,
        GetBuildVersionApiStellarConfigurationBuildVersionGetApiArg
      >({
        query: () => ({ url: `/api/stellar/configuration/build_version/` }),
        providesTags: ['CONFIGURATION'],
      }),
      initializeExperimentApiStellarExperimentsInitPost: build.query<
        InitializeExperimentApiStellarExperimentsInitPostApiResponse,
        InitializeExperimentApiStellarExperimentsInitPostApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/init/`, method: 'POST', body: queryArg.experimentInitialize }),
        providesTags: ['EXPERIMENT'],
      }),
      getExperimentsApiStellarExperimentsGet: build.query<GetExperimentsApiStellarExperimentsGetApiResponse, GetExperimentsApiStellarExperimentsGetApiArg>({
        query: () => ({ url: `/api/stellar/experiments/` }),
        providesTags: ['EXPERIMENT'],
      }),
      createExperimentApiStellarExperimentsPost: build.mutation<
        CreateExperimentApiStellarExperimentsPostApiResponse,
        CreateExperimentApiStellarExperimentsPostApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/`, method: 'POST', body: queryArg.experimentCreate }),
        invalidatesTags: ['EXPERIMENT'],
      }),
      getExperimentApiStellarExperimentsIdGet: build.query<GetExperimentApiStellarExperimentsIdGetApiResponse, GetExperimentApiStellarExperimentsIdGetApiArg>({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}` }),
        providesTags: ['EXPERIMENT'],
      }),
      deleteExperimentApiStellarExperimentsIdDelete: build.mutation<
        DeleteExperimentApiStellarExperimentsIdDeleteApiResponse,
        DeleteExperimentApiStellarExperimentsIdDeleteApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['EXPERIMENT'],
      }),
      updateExperimentApiStellarExperimentsIdPut: build.mutation<
        UpdateExperimentApiStellarExperimentsIdPutApiResponse,
        UpdateExperimentApiStellarExperimentsIdPutApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}`, method: 'PUT', body: queryArg.experimentUpdate }),
        invalidatesTags: ['EXPERIMENT'],
      }),
      pruneExperimentsApiStellarExperimentsPrunePost: build.mutation<
        PruneExperimentsApiStellarExperimentsPrunePostApiResponse,
        PruneExperimentsApiStellarExperimentsPrunePostApiArg
      >({
        query: () => ({ url: `/api/stellar/experiments/prune/`, method: 'POST' }),
        invalidatesTags: ['EXPERIMENT'],
      }),
      getRepertoireDataApiStellarExperimentsIdRepertoireDataGet: build.query<
        GetRepertoireDataApiStellarExperimentsIdRepertoireDataGetApiResponse,
        GetRepertoireDataApiStellarExperimentsIdRepertoireDataGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}/repertoire_data` }),
        providesTags: ['EXPERIMENT'],
      }),
      getSummaryDataApiStellarExperimentsIdSummaryDataGet: build.query<
        GetSummaryDataApiStellarExperimentsIdSummaryDataGetApiResponse,
        GetSummaryDataApiStellarExperimentsIdSummaryDataGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}/summary_data` }),
        providesTags: ['EXPERIMENT'],
      }),
      getAntibodySummaryDataApiStellarExperimentsIdClonotypeDefinitionAntibodySummaryDataGet: build.query<
        GetAntibodySummaryDataApiStellarExperimentsIdClonotypeDefinitionAntibodySummaryDataGetApiResponse,
        GetAntibodySummaryDataApiStellarExperimentsIdClonotypeDefinitionAntibodySummaryDataGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}/${queryArg.clonotypeDefinition}/antibody_summary_data` }),
        providesTags: ['EXPERIMENT'],
      }),
      getCellsApiStellarExperimentsIdCellsGet: build.query<GetCellsApiStellarExperimentsIdCellsGetApiResponse, GetCellsApiStellarExperimentsIdCellsGetApiArg>({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}/cells` }),
        providesTags: ['EXPERIMENT'],
      }),
      getClonotypeSizePerCellApiStellarExperimentsIdCellClonotypesClonotypeDefinitionGet: build.query<
        GetClonotypeSizePerCellApiStellarExperimentsIdCellClonotypesClonotypeDefinitionGetApiResponse,
        GetClonotypeSizePerCellApiStellarExperimentsIdCellClonotypesClonotypeDefinitionGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}/cell/clonotypes/${queryArg.clonotypeDefinition}` }),
        providesTags: ['EXPERIMENT'],
      }),
      getCellsWithClonotypeApiStellarExperimentsIdClonotypeDefinitionCellsGet: build.query<
        GetCellsWithClonotypeApiStellarExperimentsIdClonotypeDefinitionCellsGetApiResponse,
        GetCellsWithClonotypeApiStellarExperimentsIdClonotypeDefinitionCellsGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}/${queryArg.clonotypeDefinition}/cells` }),
        providesTags: ['EXPERIMENT'],
      }),
      getNodesApiStellarExperimentsIdNodesClonotypeDefinitionGet: build.query<
        GetNodesApiStellarExperimentsIdNodesClonotypeDefinitionGetApiResponse,
        GetNodesApiStellarExperimentsIdNodesClonotypeDefinitionGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}/nodes/${queryArg.clonotypeDefinition}` }),
        providesTags: ['EXPERIMENT'],
      }),
      getUniqueClonotypeidsApiStellarExperimentsIdClonotypeIdsClonotypeDefinitionGet: build.query<
        GetUniqueClonotypeidsApiStellarExperimentsIdClonotypeIdsClonotypeDefinitionGetApiResponse,
        GetUniqueClonotypeidsApiStellarExperimentsIdClonotypeIdsClonotypeDefinitionGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.id}/clonotype_ids/${queryArg.clonotypeDefinition}` }),
        providesTags: ['EXPERIMENT'],
      }),
      getTaskStatusForAnalysisApiStellarExperimentsExperimentIdTaskGet: build.query<
        GetTaskStatusForAnalysisApiStellarExperimentsExperimentIdTaskGetApiResponse,
        GetTaskStatusForAnalysisApiStellarExperimentsExperimentIdTaskGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.experimentId}/task` }),
        providesTags: ['EXPERIMENT'],
      }),
      downloadFileApiStellarExperimentsExperimentIdDownloadGet: build.query<
        DownloadFileApiStellarExperimentsExperimentIdDownloadGetApiResponse,
        DownloadFileApiStellarExperimentsExperimentIdDownloadGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.experimentId}/download`, params: { file_path: queryArg.filePath } }),
        providesTags: ['EXPERIMENT'],
      }),
      fetchAntibodyTableDataApiStellarExperimentsExperimentIdAntibodyTablePost: build.mutation<
        FetchAntibodyTableDataApiStellarExperimentsExperimentIdAntibodyTablePostApiResponse,
        FetchAntibodyTableDataApiStellarExperimentsExperimentIdAntibodyTablePostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/stellar/experiments/${queryArg.experimentId}/antibody-table/`,
          method: 'POST',
          body: queryArg.antibodyTableRequest,
        }),
        invalidatesTags: ['EXPERIMENT'],
      }),
      getProcessingStatsApiStellarExperimentsExperimentIdProcessingStatsGet: build.query<
        GetProcessingStatsApiStellarExperimentsExperimentIdProcessingStatsGetApiResponse,
        GetProcessingStatsApiStellarExperimentsExperimentIdProcessingStatsGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.experimentId}/processing-stats` }),
        providesTags: ['EXPERIMENT'],
      }),
      getPendingProcessingStepStatusApiStellarExperimentsExperimentIdPendingProcessingStatusGet: build.query<
        GetPendingProcessingStepStatusApiStellarExperimentsExperimentIdPendingProcessingStatusGetApiResponse,
        GetPendingProcessingStepStatusApiStellarExperimentsExperimentIdPendingProcessingStatusGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/experiments/${queryArg.experimentId}/pending-processing-status` }),
        providesTags: ['EXPERIMENT'],
      }),
      createExportApiStellarExportExperimentUuidPost: build.mutation<
        CreateExportApiStellarExportExperimentUuidPostApiResponse,
        CreateExportApiStellarExportExperimentUuidPostApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/export/${queryArg.experimentUuid}/`, method: 'POST', body: queryArg.exportCreate }),
        invalidatesTags: ['EXPORT'],
      }),
      modifyExportApiStellarExportExportUuidPatch: build.mutation<
        ModifyExportApiStellarExportExportUuidPatchApiResponse,
        ModifyExportApiStellarExportExportUuidPatchApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/export/${queryArg.exportUuid}/`, method: 'PATCH', body: queryArg.exportUpdate }),
        invalidatesTags: ['EXPORT'],
      }),
      getExportApiStellarExportExportUuidGet: build.query<GetExportApiStellarExportExportUuidGetApiResponse, GetExportApiStellarExportExportUuidGetApiArg>({
        query: (queryArg) => ({ url: `/api/stellar/export/${queryArg.exportUuid}/` }),
        providesTags: ['EXPORT'],
      }),
      deleteExportApiStellarExportExportUuidDelete: build.mutation<
        DeleteExportApiStellarExportExportUuidDeleteApiResponse,
        DeleteExportApiStellarExportExportUuidDeleteApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/export/${queryArg.exportUuid}/`, method: 'DELETE' }),
        invalidatesTags: ['EXPORT'],
      }),
      getExperimentExportsApiStellarExportExperimentUuidExportsGet: build.query<
        GetExperimentExportsApiStellarExportExperimentUuidExportsGetApiResponse,
        GetExperimentExportsApiStellarExportExperimentUuidExportsGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/export/${queryArg.experimentUuid}/exports/` }),
        providesTags: ['EXPORT'],
      }),
      searchGenesApiStellarSearchExperiementExperimentIdGenesGet: build.query<
        SearchGenesApiStellarSearchExperiementExperimentIdGenesGetApiResponse,
        SearchGenesApiStellarSearchExperiementExperimentIdGenesGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/stellar/search/experiement/${queryArg.experimentId}/genes/`,
          params: { search_string: queryArg.searchString, threshold: queryArg.threshold, limit: queryArg.limit, use_user_cache: queryArg.useUserCache },
        }),
        providesTags: ['SEARCH'],
      }),
      uploadFileApiStellarUploadPost: build.mutation<UploadFileApiStellarUploadPostApiResponse, UploadFileApiStellarUploadPostApiArg>({
        query: (queryArg) => ({ url: `/api/stellar/upload/`, method: 'POST', body: queryArg.bodyUploadFileApiStellarUploadPost }),
        invalidatesTags: ['UPLOAD'],
      }),
      deleteFileApiStellarUploadExperimentIdFileNameDelete: build.mutation<
        DeleteFileApiStellarUploadExperimentIdFileNameDeleteApiResponse,
        DeleteFileApiStellarUploadExperimentIdFileNameDeleteApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/upload${queryArg.experimentId}/${queryArg.fileName}`, method: 'DELETE' }),
        invalidatesTags: ['UPLOAD'],
      }),
      validateAntibodyCsvFileApiStellarUploadValidateExperimentIdFileNamePost: build.mutation<
        ValidateAntibodyCsvFileApiStellarUploadValidateExperimentIdFileNamePostApiResponse,
        ValidateAntibodyCsvFileApiStellarUploadValidateExperimentIdFileNamePostApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/upload/validate/${queryArg.experimentId}/${queryArg.fileName}`, method: 'POST' }),
        invalidatesTags: ['UPLOAD'],
      }),
      getValidationResultApiStellarUploadExperimentIdValidationResultsGet: build.query<
        GetValidationResultApiStellarUploadExperimentIdValidationResultsGetApiResponse,
        GetValidationResultApiStellarUploadExperimentIdValidationResultsGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/upload/${queryArg.experimentId}/validation_results`, params: { file_name: queryArg.fileName } }),
        providesTags: ['UPLOAD'],
      }),
      listProfilingReportsApiStellarProfilingReportsGet: build.query<
        ListProfilingReportsApiStellarProfilingReportsGetApiResponse,
        ListProfilingReportsApiStellarProfilingReportsGetApiArg
      >({
        query: () => ({ url: `/api/stellar/profiling/reports` }),
        providesTags: ['PROFILING'],
      }),
      getProfileApiStellarProfilingReportsRelPathGet: build.query<
        GetProfileApiStellarProfilingReportsRelPathGetApiResponse,
        GetProfileApiStellarProfilingReportsRelPathGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/stellar/profiling/reports/${queryArg.relPath}` }),
        providesTags: ['PROFILING'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as generatedOpenAPI };
export type StartClonotypeAnalysisApiStellarAnalysisExperimentIdClonotypeAnalysisPostApiResponse =
  /** status 200 Successful Response */ ClonotypeAnalysisResponse;
export type StartClonotypeAnalysisApiStellarAnalysisExperimentIdClonotypeAnalysisPostApiArg = {
  experimentId: string;
  clonotypeId: number;
  clonotypeMethod: ClonotypingMethod;
  barcodes: string[];
};
export type GetBuildVersionApiStellarConfigurationBuildVersionGetApiResponse = /** status 200 Successful Response */ BuildVersionResponse;
export type GetBuildVersionApiStellarConfigurationBuildVersionGetApiArg = void;
export type InitializeExperimentApiStellarExperimentsInitPostApiResponse = /** status 200 Successful Response */ ExperimentResponse;
export type InitializeExperimentApiStellarExperimentsInitPostApiArg = {
  experimentInitialize: ExperimentInitialize;
};
export type GetExperimentsApiStellarExperimentsGetApiResponse = /** status 200 Successful Response */ ExperimentResponseWithSummary[];
export type GetExperimentsApiStellarExperimentsGetApiArg = void;
export type CreateExperimentApiStellarExperimentsPostApiResponse = /** status 200 Successful Response */ ExperimentResponse;
export type CreateExperimentApiStellarExperimentsPostApiArg = {
  experimentCreate: ExperimentCreate;
};
export type GetExperimentApiStellarExperimentsIdGetApiResponse = /** status 200 Successful Response */ ExperimentResponse;
export type GetExperimentApiStellarExperimentsIdGetApiArg = {
  id: string;
};
export type DeleteExperimentApiStellarExperimentsIdDeleteApiResponse = /** status 200 Successful Response */ any;
export type DeleteExperimentApiStellarExperimentsIdDeleteApiArg = {
  id: string;
};
export type UpdateExperimentApiStellarExperimentsIdPutApiResponse = /** status 200 Successful Response */ ExperimentResponse;
export type UpdateExperimentApiStellarExperimentsIdPutApiArg = {
  id: string;
  experimentUpdate: ExperimentUpdate;
};
export type PruneExperimentsApiStellarExperimentsPrunePostApiResponse = /** status 200 Successful Response */ any;
export type PruneExperimentsApiStellarExperimentsPrunePostApiArg = void;
export type GetRepertoireDataApiStellarExperimentsIdRepertoireDataGetApiResponse = /** status 200 Successful Response */ RepertoireDataResponse;
export type GetRepertoireDataApiStellarExperimentsIdRepertoireDataGetApiArg = {
  id: string;
};
export type GetSummaryDataApiStellarExperimentsIdSummaryDataGetApiResponse = /** status 200 Successful Response */ SummaryResponse;
export type GetSummaryDataApiStellarExperimentsIdSummaryDataGetApiArg = {
  id: string;
};
export type GetAntibodySummaryDataApiStellarExperimentsIdClonotypeDefinitionAntibodySummaryDataGetApiResponse =
  /** status 200 Successful Response */ AntibodySummaryResponse;
export type GetAntibodySummaryDataApiStellarExperimentsIdClonotypeDefinitionAntibodySummaryDataGetApiArg = {
  id: string;
  clonotypeDefinition: ClonotypeDefinitionEnum;
};
export type GetCellsApiStellarExperimentsIdCellsGetApiResponse = /** status 200 Successful Response */ CellResponse[];
export type GetCellsApiStellarExperimentsIdCellsGetApiArg = {
  id: string;
};
export type GetClonotypeSizePerCellApiStellarExperimentsIdCellClonotypesClonotypeDefinitionGetApiResponse =
  /** status 200 Successful Response */ ClonotypeCellResponse[];
export type GetClonotypeSizePerCellApiStellarExperimentsIdCellClonotypesClonotypeDefinitionGetApiArg = {
  id: string;
  clonotypeDefinition: ClonotypeDefinitionEnum;
};
export type GetCellsWithClonotypeApiStellarExperimentsIdClonotypeDefinitionCellsGetApiResponse =
  /** status 200 Successful Response */ CellResponseWithClonotype[];
export type GetCellsWithClonotypeApiStellarExperimentsIdClonotypeDefinitionCellsGetApiArg = {
  id: string;
  clonotypeDefinition: ClonotypeDefinitionEnum;
};
export type GetNodesApiStellarExperimentsIdNodesClonotypeDefinitionGetApiResponse = /** status 200 Successful Response */ NodeResponse[];
export type GetNodesApiStellarExperimentsIdNodesClonotypeDefinitionGetApiArg = {
  id: string;
  clonotypeDefinition: ClonotypeDefinitionEnum;
};
export type GetUniqueClonotypeidsApiStellarExperimentsIdClonotypeIdsClonotypeDefinitionGetApiResponse = /** status 200 Successful Response */ number[];
export type GetUniqueClonotypeidsApiStellarExperimentsIdClonotypeIdsClonotypeDefinitionGetApiArg = {
  id: string;
  clonotypeDefinition: ClonotypeDefinitionEnum;
};
export type GetTaskStatusForAnalysisApiStellarExperimentsExperimentIdTaskGetApiResponse = /** status 200 Successful Response */ AnalysisStateEnum | null;
export type GetTaskStatusForAnalysisApiStellarExperimentsExperimentIdTaskGetApiArg = {
  experimentId: string;
};
export type DownloadFileApiStellarExperimentsExperimentIdDownloadGetApiResponse = /** status 200 Successful Response */ any;
export type DownloadFileApiStellarExperimentsExperimentIdDownloadGetApiArg = {
  experimentId: string;
  filePath: string;
};
export type FetchAntibodyTableDataApiStellarExperimentsExperimentIdAntibodyTablePostApiResponse = /** status 200 Successful Response */ AntibodyTableResponse;
export type FetchAntibodyTableDataApiStellarExperimentsExperimentIdAntibodyTablePostApiArg = {
  experimentId: string;
  antibodyTableRequest: AntibodyTableRequest;
};
export type GetProcessingStatsApiStellarExperimentsExperimentIdProcessingStatsGetApiResponse =
  /** status 200 Successful Response */ ProcessingStatsResponse | null;
export type GetProcessingStatsApiStellarExperimentsExperimentIdProcessingStatsGetApiArg = {
  experimentId: string;
};
export type GetPendingProcessingStepStatusApiStellarExperimentsExperimentIdPendingProcessingStatusGetApiResponse =
  /** status 200 Successful Response */ CurrentProcessingStatusResponse | null;
export type GetPendingProcessingStepStatusApiStellarExperimentsExperimentIdPendingProcessingStatusGetApiArg = {
  experimentId: string;
};
export type CreateExportApiStellarExportExperimentUuidPostApiResponse = /** status 200 Successful Response */ ExportResponse;
export type CreateExportApiStellarExportExperimentUuidPostApiArg = {
  experimentUuid: string;
  exportCreate: ExportCreate;
};
export type ModifyExportApiStellarExportExportUuidPatchApiResponse = /** status 200 Successful Response */ ExportResponse;
export type ModifyExportApiStellarExportExportUuidPatchApiArg = {
  exportUuid: string;
  exportUpdate: ExportUpdate;
};
export type GetExportApiStellarExportExportUuidGetApiResponse = /** status 200 Successful Response */ ExportResponse;
export type GetExportApiStellarExportExportUuidGetApiArg = {
  exportUuid: string;
};
export type DeleteExportApiStellarExportExportUuidDeleteApiResponse = /** status 200 Successful Response */ any;
export type DeleteExportApiStellarExportExportUuidDeleteApiArg = {
  exportUuid: string;
};
export type GetExperimentExportsApiStellarExportExperimentUuidExportsGetApiResponse = /** status 200 Successful Response */ ExportResponse[];
export type GetExperimentExportsApiStellarExportExperimentUuidExportsGetApiArg = {
  experimentUuid: string;
};
export type SearchGenesApiStellarSearchExperiementExperimentIdGenesGetApiResponse = /** status 200 Successful Response */ string[];
export type SearchGenesApiStellarSearchExperiementExperimentIdGenesGetApiArg = {
  experimentId: string;
  searchString: string;
  threshold?: number;
  limit?: number;
  useUserCache?: boolean;
};
export type UploadFileApiStellarUploadPostApiResponse = /** status 200 Successful Response */ UploadResponse;
export type UploadFileApiStellarUploadPostApiArg = {
  bodyUploadFileApiStellarUploadPost: BodyUploadFileApiStellarUploadPost;
};
export type DeleteFileApiStellarUploadExperimentIdFileNameDeleteApiResponse = /** status 200 Successful Response */ any;
export type DeleteFileApiStellarUploadExperimentIdFileNameDeleteApiArg = {
  experimentId: string;
  fileName: string;
};
export type ValidateAntibodyCsvFileApiStellarUploadValidateExperimentIdFileNamePostApiResponse = /** status 200 Successful Response */ any;
export type ValidateAntibodyCsvFileApiStellarUploadValidateExperimentIdFileNamePostApiArg = {
  experimentId: string;
  fileName: string;
};
export type GetValidationResultApiStellarUploadExperimentIdValidationResultsGetApiResponse = /** status 200 Successful Response */ AntibodyValidationMetadata;
export type GetValidationResultApiStellarUploadExperimentIdValidationResultsGetApiArg = {
  experimentId: string;
  fileName: string;
};
export type ListProfilingReportsApiStellarProfilingReportsGetApiResponse = /** status 200 Successful Response */ string[];
export type ListProfilingReportsApiStellarProfilingReportsGetApiArg = void;
export type GetProfileApiStellarProfilingReportsRelPathGetApiResponse = /** status 200 Successful Response */ void;
export type GetProfileApiStellarProfilingReportsRelPathGetApiArg = {
  relPath: string;
};
export type ChainAlignmentData = {
  alignedData: {
    [key: string]: string;
  };
  similarityLine?: string | null;
  coloredIndexes: {
    [key: string]: any[];
  };
  inFileName: string;
  dnaFileName: string;
};
export type ClonotypeAnalysisResponse = {
  heavyData: ChainAlignmentData;
  lightData?: ChainAlignmentData | null;
  tanglegramImage?: string | null;
  taskId?: string | null;
  [key: string]: any;
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type ClonotypingMethod = 'cdr3_length' | 'cdr3_identity' | 'cdr3_only' | 'hilary';
export type BuildVersionResponse = {
  version: string;
  buildDate: string | null;
  releaseNotes: string;
  branch: string;
  buildNumber: number;
  sha1: string;
};
export type OrganismEnum = 'human' | 'mouse';
export type AnalysisStateEnum = 'SUCCESS' | 'PENDING' | 'FAILURE' | 'RETRY' | 'REVOKED' | 'IGNORED' | 'STARTED' | 'RECEIVED';
export type ClonotypeDefinitionEnum = 'hilary' | 'cdr3_length' | 'cdr3_identity' | 'cdr3_only';
export type ExperimentResponse = {
  id: string;
  title: string;
  description?: string | null;
  creator: string;
  creationDate: string;
  lastModified: string;
  organism: OrganismEnum;
  antibodyFile: string;
  cellFile?: string | null;
  analysisState?: AnalysisStateEnum | null;
  taskId?: string | null;
  clonotypingMethods: ClonotypeDefinitionEnum[];
};
export type ExperimentInitialize = {
  id: string;
  organism: OrganismEnum;
  cellFile?: string | null;
  antibodyFile: string;
  abFormat: '10X';
};
export type SummaryResponseBasic = {
  cellsBeforeFiltering?: number | null;
  cellsAfterFiltering?: number | null;
  cellsWithPairedVhVl?: number | null;
  cellsWithProdVhVl?: number | null;
  cellsWithUnprodVhVl?: number | null;
};
export type ExperimentResponseWithSummary = {
  id: string;
  title: string;
  description?: string | null;
  creator: string;
  creationDate: string;
  lastModified: string;
  organism: OrganismEnum;
  antibodyFile: string;
  cellFile?: string | null;
  analysisState?: AnalysisStateEnum | null;
  taskId?: string | null;
  clonotypingMethods: ClonotypeDefinitionEnum[];
  summary?: SummaryResponseBasic | null;
};
export type ExperimentCreate = {
  id: string;
  organism: OrganismEnum;
  cellFile?: string | null;
  antibodyFile: string;
  abFormat: '10X';
  title: string;
  description: string;
  annotationFile?: string | null;
  clonotypeDefinition: ClonotypeDefinitionEnum[];
  threshold: number;
  includeUnpairedHeavyChains: boolean;
};
export type ExperimentUpdate = {
  title: string;
  description: string;
};
export type IgChainRawData = {
  ighAndIgk: number;
  ighAndIgl: number;
  igh: number;
  igk: number;
  igl: number;
};
export type ImmuneGeneRawData = {
  hFamily: {
    [key: string]: number;
  };
  lFamily: {
    [key: string]: number;
  };
  kFamily: {
    [key: string]: number;
  };
};
export type FamilyGraphRawData = {
  vGene: ImmuneGeneRawData;
  jGene: ImmuneGeneRawData;
};
export type IgProductiveChainsRawData = {
  productive: number;
  unproductive: number;
};
export type HeatmapData = {
  vhGene: string[];
  vlGene: string[];
  size: number[];
};
export type CircosData = {
  layout: number[][];
  geneNames: string[];
};
export type ShmData = {
  heavyChain: number[];
  lightChain: number[];
};
export type ShmDistributionData = {
  shmAa?: ShmData | null;
  shmDna?: ShmData | null;
};
export type Bin = {
  value: number;
  count: number;
};
export type PairedBinSeries = {
  category: string;
  heavy: Bin[];
  light?: Bin[] | null;
};
export type BinnedData = {
  igIsotype?: PairedBinSeries[] | null;
  vhFamily: PairedBinSeries[];
  cloneSizeCategory: PairedBinSeries[];
};
export type RepertoireDataResponse = {
  hasIgIsotype: boolean;
  igChainRawData: IgChainRawData;
  familyGraphRawData: FamilyGraphRawData;
  igProductiveChainsRawData?: IgProductiveChainsRawData | null;
  geneDistribution?: ImmuneGeneRawData | null;
  heatmapData?: HeatmapData | null;
  circosData?: CircosData | null;
  shmDistributionData?: ShmDistributionData | null;
  cdr3LengthDistributionData?: BinnedData | null;
  shmViolinData?: BinnedData | null;
};
export type SummaryExpressionData = {
  filterId: number;
  cellsAfterGene: number;
  cellsAfterMito: number;
  medianGenesPerCell: number;
  medianUmiPerCell: number;
  cellsRemoved: number;
  numberOfDoublets: number;
  numberOfGenes: number;
};
export type SummaryResponse = {
  cellsBeforeFiltering?: number | null;
  cellsAfterFiltering?: number | null;
  cellsWithPairedVhVl?: number | null;
  cellsWithProdVhVl?: number | null;
  cellsWithUnprodVhVl?: number | null;
  vhGenesUsed?: number | null;
  vkGenesUsed?: number | null;
  vlGenesUsed?: number | null;
  cellsWithOneChain?: number | null;
  igIsotypes?: string[] | null;
  medianIghUmiPerCell?: number | null;
  medianIgkUmiPerCell?: number | null;
  medianIglUmiPerCell?: number | null;
  singletonVh?: number | null;
  singletonVl?: number | null;
  expressionData?: SummaryExpressionData | null;
};
export type AntibodySummaryResponse = {
  totalAntibodies: number;
  totalNodes: number;
  totalClonotypes: number;
  multipleCellClonotypes: number;
  singleCellClonotypes: number;
};
export type CellResponse = {
  id: number;
  barcode: string;
  heavyAminoAcidSeq?: string | null;
  heavyDnaSeq?: string | null;
  lightAminoAcidSeq?: string | null;
  lightDnaSeq?: string | null;
  irVj1Locus?: string | null;
  irVdj1Locus?: string | null;
  vhGeneFamily?: string | null;
  irVdj1VCall?: string | null;
  irVdj1CCall?: string | null;
  irVdj1JCall?: string | null;
  irVj1VCall?: string | null;
  irVj1JCall?: string | null;
  cdrh3AaLen?: number | null;
  cdrl3AaLen?: number | null;
  irVdj1Cdr1Aa?: string | null;
  irVdj1Cdr2Aa?: string | null;
  irVdj1JunctionAa?: string | null;
  irVj1Cdr1Aa?: string | null;
  irVj1Cdr2Aa?: string | null;
  irVj1JunctionAa?: string | null;
  irVdj1DuplicateCount?: number | null;
  irVj1DuplicateCount?: number | null;
  irVdj1AaMismatch?: number | null;
  irVj1AaMismatch?: number | null;
  shmValue?: string | null;
  heavyAaShmPositions?: string | null;
  lightAaShmPositions?: string | null;
  heavyLiabilities?: string | null;
  heavyLiabilityStatus?: string | null;
  lightLiabilities?: string | null;
  lightLiabilityStatus?: string | null;
  heavyAminoAcidImgtNumberings?: string | null;
  lightAminoAcidImgtNumberings?: string | null;
  rankScore?: number | null;
  liabilityScore?: number | null;
  majorityVoting?: string | null;
  leiden?: string | null;
};
export type ClonotypeCellResponse = {
  cellId: number;
  clonotypeId: number;
  clonotypeSize: number;
};
export type CellResponseWithClonotype = {
  clonotypeId?: number | null;
  clonotypeSize?: number | null;
  numberOfNodes?: number | null;
  cellId: number;
  barcode: string;
  barcodeId: string;
  heavyAminoAcidSeq?: string | null;
  lightAminoAcidSeq?: string | null;
  heavyDnaSeq?: string | null;
  lightDnaSeq?: string | null;
  heavyAminoAcidImgtNumberings?: string | null;
  lightAminoAcidImgtNumberings?: string | null;
  vhGeneFamily?: string | null;
  irVj1Locus?: string | null;
  irVdj1Locus?: string | null;
  irVdj1CCall?: string | null;
  irVdj1VCall?: string | null;
  irVj1VCall?: string | null;
  irVdj1JCall?: string | null;
  irVj1JCall?: string | null;
  irVdj1Cdr1Aa?: string | null;
  irVdj1Cdr2Aa?: string | null;
  irVdj1JunctionAa?: string | null;
  irVj1Cdr1Aa?: string | null;
  irVj1Cdr2Aa?: string | null;
  irVj1JunctionAa?: string | null;
  cdrh3AaLen?: number | null;
  cdrl3AaLen?: number | null;
  irVdj1DuplicateCount?: number | null;
  irVj1DuplicateCount?: number | null;
  irVdj1AaMismatch?: number | null;
  irVj1AaMismatch?: number | null;
  shmValue?: string | null;
  heavyAaShmPositions?: string | null;
  lightAaShmPositions?: string | null;
  heavyLiabilities?: string | null;
  heavyLiabilityStatus?: string | null;
  lightLiabilities?: string | null;
  lightLiabilityStatus?: string | null;
  rankScore?: number | null;
  liabilityScore?: number | null;
  majorityVoting?: string | null;
  leiden?: string | null;
  totalCounts?: number | null;
  annotations?: {
    [key: string]: string;
  } | null;
};
export type NodeResponse = {
  nodeId: number;
  clonotypeId: number;
  cellId?: number | null;
  cdr3Sequence: string;
  x: number;
  y: number;
  links?: number[];
  liabilityStatus?: string | null;
  shmCategory?: string | null;
  cellIds?: number[] | null;
};
export type SequenceMetadata = {
  nodeId: number;
  sequenceId: string;
  barcodes: string[];
  originalBarcodes: string[];
  aps?: number | null;
  liabilityScore?: number | null;
  shms?: number | null;
};
export type Shm = {
  index: number;
  pos: string;
  ref: string;
  residue: string;
};
export type Liability = {
  index: number;
  pos: string;
  residue: string;
  region: string;
  severity: string;
};
export type AntibodyChainData = {
  chainType: string;
  sequence: string;
  dnaSequence: string;
  vGene: string | null;
  jGene: string | null;
  igIsotype?: string | null;
  shms?: Shm[] | null;
  liabilities: Liability[] | null;
  liabilityStatus: string | null;
  regions: {
    [key: string]: string | null;
  };
  dnaRegions?: {
    [key: string]: string | null;
  } | null;
  umiCounts?: number | null;
  [key: string]: any;
};
export type SequenceData = {
  metadata: SequenceMetadata;
  heavyChain: AntibodyChainData;
  lightChain: AntibodyChainData | null;
  [key: string]: any;
};
export type RegionNumbering = {
  region: string;
  start: string;
  end: string;
};
export type AntibodyResponse = {
  id: number;
  name: string;
  sequences: SequenceData[];
  heavyNumbering: string[];
  lightNumbering?: string[] | null;
  heavyRegions: RegionNumbering[];
  lightRegions?: RegionNumbering[] | null;
  [key: string]: any;
};
export type AntibodyTableResponse = {
  clonotypes: AntibodyResponse[];
  [key: string]: any;
};
export type AntibodyNodeGroup = {
  clonotypeId: number;
  nodeId: number;
  cellIds: number[];
};
export type AntibodyTableRequest = {
  clonotypeDefinition: ClonotypeDefinitionEnum;
  nodes?: AntibodyNodeGroup[];
  barcodes: string[];
  aps: boolean;
};
export type ProcessingStepStatus = 'started' | 'completed' | 'failed';
export type ProcessingStatsResponse = {
  sequenceCount: number | null;
  analysisState: ProcessingStepStatus;
  durationSeconds: number;
};
export type ProcessingStepType = 'processing' | 'concatenation' | 'reannotation' | 'numbering' | 'shm' | 'liabilities' | 'ranking' | 'clonotyping' | 'cancel';
export type CurrentProcessingStatusResponse = {
  processingStep: ProcessingStepType;
  processingStepStatus: ProcessingStepStatus;
  stepIndex: number | null;
  totalStepCount: number;
  error?: string | null;
};
export type NodeTrackingLabel = 'Selected' | 'Sent for Synthesis' | 'Cloned' | 'Tested' | 'Needs Follow-up';
export type ExportNode = {
  nodeId: number;
  clonotypeId: number;
  cellIds: number[];
  originalBarcodes: string[];
  exportNums: number[];
  labels: NodeTrackingLabel[];
  cdr3Sequence: string;
  notes: string | null;
  evaluated: boolean;
  clonotypeDefinition: ClonotypeDefinitionEnum;
};
export type ExportResponse = {
  exportId: string;
  exportNumber: number;
  description: string;
  createdAt: string;
  nodes: ExportNode[];
};
export type ExportCreate = {
  nodeIds: number[];
};
export type ExportUpdate = {
  removeNodeIds?: number[] | null;
  addNodeIds?: number[] | null;
  description?: string | null;
};
export type UploadResponse = {
  fileLocation?: string | null;
  fileName: string;
  chunkNo: number;
  lastChunk: boolean;
};
export type BodyUploadFileApiStellarUploadPost = {
  file_chunk: Blob;
  experiment_id: string;
  file_name: string;
  chunk_no: number;
  last_chunk: boolean;
  check_header_includes?: string[] | null;
};
export type AntibodyValidationMetadata = {
  lineCount: number;
  fileRows: number;
  missingColumns: string[] | null;
  headerParsingError: string | null;
  rowParsingErrors: string[] | null;
  fileExtension: string;
  lightChainObserved: boolean;
  heavyChainObserved: boolean;
  maxSequenceLength: number;
};
export const {} = injectedRtkApi;
